import _ from 'underscore';
import v5_Collection from '@/collections/v5/collection';
import Api from '@/lib/api/api';
import Invite from '@/models/v5/invite';
import v5_Model from '@/models/v5/model';

    var Invites = new v5_Collection();
    _.extend(Invites, {
        url: function() {
            return Api.urls.invites();
        },
        model: Invite,

        create_invitation: function (identifier, model, roles, options) {
            options = (options || {});
            roles = roles.map(v5_Model.make_reference);
            options.attrs = {
                data: {
                    type: Invite.type,
                    attributes: { identifier: identifier },
                    relationships: {
                        roles: roles.map(v5_Model.make_reference),
                        owner: v5_Model.make_reference(model),
                    },
                }
            };
            return this.create({ identifier: identifier }, options);
        }

    });

    export default Invites;

